import React, { useState, useEffect, useRef } from 'react'; // useRef'i import ediyoruz
import './portfolio.css';
// ...diğer resim importların aynı kalacak...
import IMG1 from '../../assets/portfolio2.webp'
import IMG2 from '../../assets/portfolio3.webp'
import underConstIMG from '../../assets/under_construction.webp'
import sanalkolejim from '../../assets/sanalkolejim.webp'
import herbalmarketim from'../../assets/herbalmarketim.webp'
import herbalyaninda from '../../assets/herbalyaninda.webp'
import karbonenerji from '../../assets/karbonenerji.webp'
import sanalkursum from '../../assets/sanalkursum.webp'
import endustriyelisler from '../../assets/endustriyelisler.webp'
import izmirarslankarot from '../../assets/izmirarslankarot.webp'
import saksimarket from '../../assets/saksimarket.webp'
import cengizplastik from '../../assets/cengizplastik.webp'
import censantemizlik from '../../assets/censantemizlik.webp'

// Veri dizileri aynı kalıyor
const generalProjects = [
  { id: 1, image: underConstIMG, title: 'Greenrent Project', github: 'https://github.com/bilgehancomert?tab=repositories', demo: 'https://greenrent.bilgehancomert.dev/' },
  { id: 2, image: IMG1, title: 'Visionrent Project', github: 'https://github.com/bilgehancomert/visionrentProject', demo: 'https://visionrent.bilgehancomert.dev/' },
  { id: 3, image: IMG2, title: 'React Admin Project', github: 'https://github.com/bilgehancomert/reactAdminDashboardProject', demo: 'https://reactadminproject.bilgehancomert.dev/' },
  { id: 4, image: underConstIMG, title: 'E Commerce Project', github: 'https://github.com/bilgehancomert?tab=repositories', demo: 'https://ecommerceproject.bilgehancomert.dev/' }
];
const wordpressProjects = [
  { id: 1, image: sanalkolejim, title: 'Sanal Kolejim', demo: 'https://sanalkolejim.com/' },
  { id: 2, image: herbalmarketim, title: 'Herbal Marketim', demo: 'https://herbalmarketim.com/' },
  { id: 3, image: herbalyaninda, title: 'Herbal Yanında', demo: 'https://herbalyaninda.com.tr/' },
  { id: 4, image: karbonenerji, title: 'Karbon Enerji', demo: 'https://karbonenerji.com/' },
  { id: 5, image: sanalkursum, title: 'Sanal Kursum', demo: 'https://www.sanalkursum.com/' },
  { id: 6, image: endustriyelisler, title: 'Endüstriyel İşler', demo: 'https://endustriyelisler.com/' },
  { id: 7, image: izmirarslankarot, title: 'İzmir Arslan Karot', demo: 'https://izmirarslankarot.com/' },
  { id: 8, image: saksimarket, title: 'Saksı Market', demo: 'https://saksimarket.com/' },
  { id: 9, image: cengizplastik, title: 'Cengiz Plastik', demo: 'https://cengizplastik.com/' },
  { id: 10, image: censantemizlik, title: 'Censan Temzilik', demo: 'https://censantemizlik.com/' }
];

const Portfolio = () => {
  const [currentCategory, setCurrentCategory] = useState('general');
  const [currentPage, setCurrentPage] = useState(0); // Sayfaları 0'dan başlatmak daha kolay
  const [itemsPerPage, setItemsPerPage] = useState(6);
  
  // --- YENİ: Swipe/Drag ve animasyon için ref ve state'ler ---
  const containerRef = useRef(null);
  const dragStartX = useRef(0);
  const isDragging = useRef(false);
  const currentTranslate = useRef(0); // Mevcut kayma miktarını tutar
  const startTranslate = useRef(0); // Sürükleme başladığındaki kayma miktarı
  
  const currentProjects = currentCategory === 'general' ? generalProjects : wordpressProjects;
  const reversedProjects = [...currentProjects].reverse();
  const totalPages = Math.ceil(reversedProjects.length / itemsPerPage);

  // Sayfaları oluşturmak için projeleri bölümlere ayır
  const pages = [];
  for (let i = 0; i < reversedProjects.length; i += itemsPerPage) {
    pages.push(reversedProjects.slice(i, i + itemsPerPage));
  }
  
  // Ekran boyutu değiştiğinde ayarları güncelle
  useEffect(() => {
    const handleResize = () => setItemsPerPage(window.innerWidth <= 600 ? 1 : 6);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Kategori değiştiğinde slider'ı başa al
  useEffect(() => {
    setCurrentPage(0);
  }, [currentCategory]);
  
  // --- YENİ: Sayfa geçiş fonksiyonları (sonsuz döngü ile) ---
  const goToPage = (pageIndex) => {
    // Sayfa numarasının sınırlar içinde kalmasını sağla (döngü için)
    const newIndex = (pageIndex + totalPages) % totalPages;
    setCurrentPage(newIndex);
  };

  // --- YENİ: Sürükleme olayları ---
  const handleDragStart = (e) => {
    isDragging.current = true;
    dragStartX.current = e.touches ? e.touches[0].clientX : e.pageX;
    startTranslate.current = currentTranslate.current;
    // Sürüklerken animasyonu kaldır ki anlık tepki versin
    containerRef.current.querySelector('.portfolio_slider').style.transition = 'none';
    containerRef.current.style.cursor = 'grabbing';
  };
  
  const handleDragMove = (e) => {
    if (!isDragging.current) return;
    const currentX = e.touches ? e.touches[0].clientX : e.pageX;
    const deltaX = currentX - dragStartX.current;
    currentTranslate.current = startTranslate.current + deltaX;
    // Slider'ı anlık olarak kaydır
    containerRef.current.querySelector('.portfolio_slider').style.transform = `translateX(${currentTranslate.current}px)`;
  };
  
  const handleDragEnd = () => {
    if (!isDragging.current) return;
    isDragging.current = false;
    
    // Sürükleme bittiğinde animasyonu geri getir
    containerRef.current.querySelector('.portfolio_slider').style.transition = 'transform 0.5s ease';
    containerRef.current.style.cursor = 'grab';

    const containerWidth = containerRef.current.offsetWidth;
    const movedBy = currentTranslate.current - startTranslate.current;

    // Yeterince kaydırıldıysa sayfa değiştir
    if (movedBy < -50 && currentPage < totalPages - 1) {
      goToPage(currentPage + 1);
    } else if (movedBy > 50 && currentPage > 0) {
      goToPage(currentPage - 1);
    } else if (movedBy < -50 && currentPage === totalPages - 1) { // Sonsuz döngü (sondan başa)
      goToPage(0);
    } else if (movedBy > 50 && currentPage === 0) { // Sonsuz döngü (baştan sona)
      goToPage(totalPages - 1);
    } else {
      // Yeterince kaydırılmadıysa, eski pozisyona geri dön
      currentTranslate.current = -currentPage * containerWidth;
      containerRef.current.querySelector('.portfolio_slider').style.transform = `translateX(${currentTranslate.current}px)`;
    }
  };
  
  // Sayfa değiştiğinde slider'ı doğru pozisyona kaydır
  useEffect(() => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      currentTranslate.current = -currentPage * containerWidth;
      containerRef.current.querySelector('.portfolio_slider').style.transform = `translateX(${currentTranslate.current}px)`;
    }
  }, [currentPage, itemsPerPage, currentCategory]);


  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      {/* ... Kategori butonları aynı ... */}
      <div className="portfolio-buttons">
        <a className={`btn ${currentCategory === 'general' ? 'active' : ''}`} onClick={() => setCurrentCategory('general')}> General Projects </a>
        <a className={`btn ${currentCategory === 'wordpress' ? 'active' : ''}`} onClick={() => setCurrentCategory('wordpress')}> WordPress Projects </a>
      </div>
      
      <div className="container portfolio_container" ref={containerRef}
        onMouseDown={handleDragStart} onMouseMove={handleDragMove} onMouseUp={handleDragEnd} onMouseLeave={handleDragEnd}
        onTouchStart={handleDragStart} onTouchMove={handleDragMove} onTouchEnd={handleDragEnd}
      >
        <div className="portfolio_slider">
          {pages.map((pageItems, pageIndex) => (
            <div className="portfolio_page" key={pageIndex}>
              {pageItems.map(({ id, image, title, github, demo }) => (
                <article key={id} className='portfolio_item'>
                  <div className='portfolio_item-image'> <img src={image} alt={title} /> </div>
                  <h3>{title}</h3>
                  <div className="portfolio_item-cta">
                    {github && <a href={github} className='btn' rel="nofollow" target='_blank'> Github </a>}
                    <a href={demo} className='btn btn-primary' rel="nofollow" target='_blank'> Live Demo </a>
                  </div>
                </article>
              ))}
            </div>
          ))}
        </div>
      </div>

      {totalPages > 1 && (
        <div className="portfolio_pagination">
          {Array.from({ length: totalPages }, (_, index) => (
            <span
              key={index}
              className={`pagination_dot ${currentPage === index ? 'active' : ''}`}
              onClick={() => goToPage(index)}
            />
          ))}
        </div>
      )}
    </section>
  )
}

export default Portfolio;